export default "__VITE_ASSET__BDWLSh4G__"